(function(){
  var propertyChangeTimer;

  Pegasus.SliderView = Ember.View.extend({
    templateName: 'controls/slider',
    classNames: ['slider-control'],
    showInput: false,
    unit: 'px',
    slider: null,
    propertyBinding: null,
    propertyChangeTimer: null,
    targetLineMark: -1,
    targetLineStyle: function(){
      var targetLineMark = this.get('targetLineMark');
      var position, minimum, maximum, sliderWidth, unit;

      if ( targetLineMark < 0 ) {
        return 'display:none;';
      }

      minimum = this.get('minimum');
      maximum = this.get('maximum');
      sliderWidth = this.$('.slider').width();
      unit = sliderWidth / (maximum - minimum);
      position = (targetLineMark - minimum) * unit;

      return 'left:'+position+'px';
    }.property('targetLineMark', 'minimum', 'maximum'),
    didInsertElement: function(){
      this._super();
      //Em.run.scheduleOnce('afterRender', this, function(){
        var slider = window.noUiSlider.create(this.$('.slider')[0], this.options());
        this.set('slider', slider);
        slider.on('slide', function(values){
          this.set('property', ""+Math.floor( values[0] ) );
          Em.run.scheduleOnce('afterRender', this, 'sliderUpdated');
        }.bind(this));
      //});
      Em.propertyDidChange(this, 'targetLineMark');
    },
    propertyWithUnit: function(_, value){
      var unit = this.get('unit'),
        prop = this.get('property');

      if ( isNaN( prop ) ) {
        this.set('property', '0');
        // let this property recalculate
        return;
      }

      if ( typeof( value ) !== 'undefined') {

        value = window.parseInt( value, 10 );

        if ( isNaN( value ) ) {
          value = 0;
        }

        // this must be a string or else attributeBindings
        // will not propagate 0 (integer)
        Em.run.next(this, function(){
          this.set( 'property', ""+ value);
          this.didChangeProperty();
        });

        return value + unit;
      }

      return prop ? prop + unit : "";
    }.property('property'),
    didChangeProperty: function(){
      this.get('slider').set( this.get('property') );
    },
    options: function(){
      return {
        start: [this.get('property')],
        range: {
          'min': 0,
          'max': 100
        }
      };
    }
  });
})();
